import { type BaseErrorExtensions } from '@adornis/validation/errors/BaseError.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class UserNotFoundError extends ExpectedError {
  static override _class = 'UserNotFoundError';
  override message;

  public constructor(userID?: string, extensions: BaseErrorExtensions = {}) {
    super('UserNotFoundError', { ...extensions, translationKey: 'USER_NOT_FOUND_ERROR', userID });
    this.message = 'Benutzer nicht gefunden.';
  }

  static override createFromDetails(message: string, extensions: BaseErrorExtensions) {
    return new this(extensions.userID, extensions);
  }
}
